module.exports = __webpack_public_path__ + "static/media/p105p.0982aaa9.jpg";